<app-header (toggleMenu)="toggleSidebar()" [fullWidth]="isFullWidth"></app-header>

<app-sidebar [isOpen]="sidebarOpen"></app-sidebar>

<!-- Overlay -->
<div class="drawer-overlay" [class.active]="sidebarOpen" (click)="toggleSidebar()"></div>

<!-- Contenido principal -->
<div class="main-content" [class.sidebar-open]="sidebarOpen" [class.full-width]="isFullWidth">
  <div class="welcome-section" >
    <h1 class="welcome-title">{{ (title$ | async) || ' ' }}</h1>
  </div>
  <ng-template #noTitle></ng-template>

  <router-outlet></router-outlet>
</div>
